import script from "./PrecognitionSession.vue?vue&type=script&setup=true&lang=js"
export * from "./PrecognitionSession.vue?vue&type=script&setup=true&lang=js"

import "./PrecognitionSession.vue?vue&type=style&index=0&id=146a570a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-146a570a"]])

export default __exports__